import { NavLink } from "react-router-dom";
import { quickEntries } from "./navItems";
import { useFavorites } from "@/hooks/useFavorites";
import { episodes } from "@/mocks/episodes";
import { characters } from "@/mocks/characters";

export default function SiteSidebar() {
  const { favorites } = useFavorites();

  const favoriteItems = favorites
    .map((item) => {
      if (item.kind === "episode") {
        const episode = episodes.find((entry) => entry.id === item.id);
        if (!episode) return null;
        return {
          key: `ep-${episode.id}`,
          label: `第${episode.number}集 ${episode.title}`,
          to: `/episode/${episode.id}`,
          icon: "ri-film-line",
        };
      }
      const character = characters.find((entry) => entry.id === item.id);
      if (!character) return null;
      return {
        key: `ch-${character.id}`,
        label: character.name,
        to: `/character/${character.id}`,
        icon: "ri-user-star-line",
      };
    })
    .filter((entry): entry is { key: string; label: string; to: string; icon: string } => entry !== null);

  return (
    <aside className="hidden lg:block w-64 shrink-0">
      <div className="sticky top-24 space-y-5">
        <div className="rounded-lg bg-background-50 border border-background-200 p-4">
          <h2 className="font-heading text-base text-foreground-950 mb-3">快捷入口</h2>
          <div className="space-y-1.5">
            {quickEntries.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 px-3 py-2.5 rounded-md text-sm font-label transition-colors cursor-pointer ${
                    isActive ? "bg-primary-100 text-primary-800" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                <span className="w-7 h-7 flex items-center justify-center rounded-md bg-background-100 text-primary-600 text-base">
                  <i className={item.icon}></i>
                </span>
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>

        <div className="rounded-lg bg-background-50 border border-background-200 p-4">
          <div className="flex items-center justify-between mb-3">
            <h2 className="font-heading text-base text-foreground-950 flex items-center gap-1.5">
              <i className="ri-heart-3-fill text-primary-500"></i>我的收藏
            </h2>
            <span className="text-xs font-label px-2 py-0.5 rounded-full bg-accent-100 text-accent-900">
              {favoriteItems.length}
            </span>
          </div>
          {favoriteItems.length === 0 ? (
            <p className="text-xs text-foreground-500 leading-relaxed font-label">
              还没有收藏内容。在剧情或角色详情页点击收藏，这里会实时显示。
            </p>
          ) : (
            <div className="space-y-1">
              {favoriteItems.slice(0, 8).map((item) => (
                <NavLink
                  key={item.key}
                  to={item.to}
                  className="flex items-center gap-2 px-2 py-2 rounded-md text-xs font-label text-foreground-700 hover:bg-background-100 cursor-pointer"
                >
                  <i className={`${item.icon} text-primary-500`}></i>
                  <span className="truncate">{item.label}</span>
                </NavLink>
              ))}
            </div>
          )}
        </div>

        <div className="rounded-lg bg-accent-50 border border-accent-200 p-4">
          <p className="font-heading text-sm text-accent-900 mb-1">正版观看提醒</p>
          <p className="text-xs text-foreground-600 leading-relaxed font-label">
            本站不提供播放与下载，正片请前往官方授权平台观看。
          </p>
          <NavLink
            to="/guide"
            className="inline-flex items-center gap-1 mt-2 text-xs font-label text-primary-700 hover:text-primary-800 cursor-pointer"
          >
            查看观看指南 <i className="ri-arrow-right-line"></i>
          </NavLink>
        </div>
      </div>
    </aside>
  );
}